/* eslint-disable no-unused-vars */
import stringHash from "string-hash";
import { getSKUData, getSKUDataFromDb, getSKUDataFromS3 } from "./SKUClient";
import { ASSET_EVENTS, ASSET_TYPES } from "../constants";
import Event from "./Event";
import { cleanGLBFromAssets } from "./MachineUtils";
import mainjson from "./preprod-engine.json";
import skuTranslatorV0V1 from "./SkuTranslator";

const sceneConfigJSON = require("../app/pepperfry_config.json");

const mod = () => {
  const firebaseConfigs = {};
  const configs = {};
  const sceneConfig = sceneConfigJSON;
  const saveConfig = (url) => (response) => {
    configs[url] = response.json();
    Event.sendSMEvent(ASSET_EVENTS.CONFIG_LOADED, url);
  };
  const hasConfig = (url) => url in configs;

  // const sampleConfig = [
  //   { type: "GLB1", createdTimeStamp: 1640338029585 },
  //   { type: "GLB2", createdTimeStamp: 1640338029444 },
  //   { type: "GLB3", createdTimeStamp: Date.now() },
  //   { type: "GLB4", createdTimeStamp: 1640336029585 },
  //   { type: "GLB5", createdTimeStamp: 1640339029585 },
  // ]
  const getNewGLBAsset = (v0Config) => {
    const { producedAssets, updatedTimeStamp } = v0Config;
    if (!producedAssets || producedAssets?.length === 0) return null;
    const sortedAssets = producedAssets
      .filter((asset) => !!asset.createdTimeStamp)
      .sort((a, b) => b.createdTimeStamp - a.createdTimeStamp);
    let [latestGLBAsset] = sortedAssets;
    if (updatedTimeStamp) {
      const newAsset = sortedAssets.find(
        (asset) => asset.createdTimeStamp > updatedTimeStamp
      );
      if (newAsset) latestGLBAsset = newAsset;
    }
    return latestGLBAsset;
  };

  return {
    loadConfig: (url) => {
      fetch(url).then(saveConfig(url));
    },
    loadDefaultConfigFromS3: async (skuId) => {
      const configURL = `https://developers-test-ap-south-1.s3.ap-south-1.amazonaws.com/testAssets/skuConfigs/${skuId}.json`;
      await fetch(configURL).then(async (response) => {
        firebaseConfigs[skuId] = await response.json();
        console.log("config downloaded", firebaseConfigs[skuId]);
      });
    },
    loadConfigFromFirebase: async (context) => {
      const { skuId } = context;
      console.log("firebase loading", skuId);
      // await getSKUData(skuId).then(async (v0Config) => {
      const v0Config = mainjson.skudata[skuId];
      if (v0Config) {
        const translatedConfig = await skuTranslatorV0V1(v0Config, skuId);
        firebaseConfigs[skuId] = translatedConfig;
        console.log(
          "config loaded config loader",
          JSON.stringify(translatedConfig)
        );

        Event.sendSMEvent(ASSET_EVENTS.CONFIG_LOADED, {
          loadType: "SKU_CONFIG",
        });
      } else {
        Event.sendSMEvent(ASSET_EVENTS.CONFIG_NOT_LOADED, {
          loadType: "SKU_CONFIG",
        });
      }
      // });
    },
    loadConfigFromS3: async (context, cleanAssetData) => {
      await getSKUDataFromS3(context).then((v0Config) => {
        if (v0Config) {
          const translatedConfig = cleanAssetData(v0Config);
          firebaseConfigs[context.skuId] = translatedConfig;
          console.log(
            "config loaded config loader",
            JSON.stringify(translatedConfig)
          );
          Event.sendSMEvent(ASSET_EVENTS.CONFIG_LOADED, {
            loadType: "SKU_CONFIG",
          });
        } else {
          Event.sendSMEvent(ASSET_EVENTS.CONFIG_NOT_LOADED, {
            loadType: "SKU_CONFIG",
          });
        }
      });
    },
    loadConfigFromDb: async (
      context,
      generateDefaultSKUConfig,
      cleanAssetData
    ) => {
      await getSKUDataFromDb(context).then((v0Config) => {
        // await getSKUData(skuId).then(async (v0Config) => {
        if (v0Config) {
          console.log(
            "🚀 ~ file: ConfigLoader.js ~ line 28 ~ //awaitgetSKUData ~ v0Config",
            v0Config,
            context.skuId
          );

          const latestGLBAsset = getNewGLBAsset(v0Config);
          const skuSelectedGlB = Object.keys(v0Config?.assets ?? []).find(
            (hash) => {
              if (String(hash) === String(v0Config.models.path))
                return v0Config.assets[hash];
              return null;
            }
          );
          if ("models" in v0Config) {
            // Add the new produced assets to the asset
            if (latestGLBAsset) {
              const hashed = stringHash(latestGLBAsset.url);
              v0Config.assets[hashed] = {
                type: ASSET_TYPES.GLTF,
                url: latestGLBAsset.url,
              };
              // Update the hash to the model
              if (latestGLBAsset.url !== skuSelectedGlB.url)
                v0Config.models.path = String(hashed);
            }

            const filteredAssets = cleanGLBFromAssets(
              v0Config.assets,
              v0Config.models.path
            );
            v0Config.assets = filteredAssets;
            const translatedConfig = cleanAssetData(v0Config);
            firebaseConfigs[context.skuId] = translatedConfig;
          } else {
            const defaultConfig = generateDefaultSKUConfig(
              v0Config,
              latestGLBAsset
            );
            const filteredAssets = cleanGLBFromAssets(
              defaultConfig.assets,
              defaultConfig.models.path
            );
            v0Config.assets = filteredAssets;
            const translatedConfig = cleanAssetData({
              ...defaultConfig,
              ...v0Config,
            });
            firebaseConfigs[context.skuId] = translatedConfig;
          }
          Event.sendSMEvent(ASSET_EVENTS.CONFIG_LOADED, {
            loadType: "SKU_CONFIG",
          });
        } else {
          Event.sendSMEvent(ASSET_EVENTS.CONFIG_NOT_LOADED, {
            loadType: "SKU_CONFIG",
          });
        }
      });
    },
    getFullSkuConfig: (skuId) => {
      return firebaseConfigs[skuId];
    },
    getSKUConfig: (skuId) => {
      console.log(
        "getskuConfig call",
        skuId,
        JSON.stringify(firebaseConfigs[skuId])
      );
      return firebaseConfigs[skuId];
    },
    getConfig: (url) => sceneConfig(url),
    hasConfig,
    eventForConfig: (url) => {
      if (hasConfig(url)) Event.sendSMEvent(ASSET_EVENTS.LOADED, url);
    },
  };
};

const ConfigLoader = mod();
export default ConfigLoader;
